<script setup lang="ts">
import Chip from 'primevue/chip'

import RIcon from '../RIcon/RIcon.vue'

import type { RChipProps } from './RChip.types.ts'

defineEmits<(e: 'remove') => void>()

defineProps<RChipProps>()
</script>

<template>
  <Chip
    v-bind="$props"
    @remove="$emit('remove')"
    :unstyled="false"
    :class="{
      '!bg-transparent !border': outlined,
      [`p-chip--${severity}`]: severity,
    }"
  >
    <template
      v-if="icon"
      #icon
    >
      <RIcon :icon="icon" />
    </template>
    <slot />
    <template #removeicon>
      <RIcon
        icon="icon-[ph--x]"
        class="!w-3 !h-3 cursor-pointer"
        @click="$emit('remove')"
      ></RIcon>
    </template>
  </Chip>
</template>

<style src="./RChip.css"></style>
